import { render, staticRenderFns } from "./PrivacyAndCookies.vue?vue&type=template&id=68e22bd8&scoped=true&"
import script from "./PrivacyAndCookies.vue?vue&type=script&lang=ts&"
export * from "./PrivacyAndCookies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e22bd8",
  null
  
)

export default component.exports